import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import _ from 'lodash';

import { useFetchLines } from './use-fetch-lines';
import { useFetchPermissionaries } from './use-fetch-permissionaries';

export const useFetchFilteredPermissionariesByLine = (config = { lineRequest: { boOrdenarPorNuLinha: false }}) => {
  const [filteredPermissionaries, setFilteredPermissionaries] = useState([]);
  const { values, setFieldValue } = useFormikContext();

  const { loading: loadingPermissionaries, permissionaries } = useFetchPermissionaries();
  const { loading: LoadingLines, lines } = useFetchLines(config.lineRequest);

  const loading = LoadingLines || loadingPermissionaries;

  useEffect(() => {
    if (!values.linhas) return;
    if (values.linhas.length === 0) {
      setFilteredPermissionaries(permissionaries);
    } else {
      setFilteredPermissionaries(filterPermissionariesByLine(values.linhas, permissionaries));
    }
  }, [values.linhas, permissionaries]);

  useEffect(() => {
    if (!values.linhas) return;
    if (!values.permissionarios) return;
    const permiList = getPermissionaryObjectsFromIds(values.permissionarios, permissionaries);
    const filtered = filterPermissionariesByLine(values.linhas, permiList);
    const onlyCdLinhaPermissionario = filtered.map(
      permissionary => permissionary.cdLinhaPermissionario
    );
    setFieldValue('permissionarios', onlyCdLinhaPermissionario);
    // eslint-disable-next-line
  }, [values.linhas]);

  return { permissionaries: filteredPermissionaries, lines, loading };
};

function filterPermissionariesByLine(linesIds, permissionariesList) {
  let filtered = [];
  linesIds.forEach(lineId => {
    permissionariesList.filter(permi => +permi.cdLinha === +lineId)
                       .forEach(p => filtered.push(p));
  });
  return _.uniqBy(filtered, 'cdLinhaPermissionario');
}

function getPermissionaryObjectsFromIds(idList, permissionaryList) {
  let filtered = [];
  idList.forEach(permiId => {
    const foundPermi = permissionaryList.find(permi => +permi.cdLinhaPermissionario === +permiId);
    if (foundPermi) filtered.push(foundPermi);
  });
  return filtered;
}
